import React, { FC, useEffect, useState } from 'react'
import Button from '../../../../../components/Atoms/Button/Button'
import useForm, { OnSubmitParams } from '../../../../../components/Core/Hooks/useForm/useForm'
import {
  FormStyle,
  FormHeader,
  FormTitle,
  FormFooter,
  FormFooterActionsLeft,
  FormFooterActionsRight,
  FormDescription,
} from '../../../../../components/Organisms/Form/Form.styles'
import utils from '../../../../../components/Organisms/Form/utils'
import config from './config'
import t from '../../../../../translations/main'
import { Trans } from 'react-i18next'
import { FormProps } from '../../../../Pages/Onboarding/types'
import { useDropdownOptions } from 'src/components/Core/Context/OnboardingContext'
import timezones from './timezones'

const BankDetailsForm: FC<FormProps> = props => {
  const [initialRender, setInitialRender] = useState(false)
  const { dropdownOptions } = useDropdownOptions()

  const submitForm = (data: OnSubmitParams) => {
    const { submit } = props
    /* eslint-disable @typescript-eslint/no-unused-vars */
    const { timezonesDropdown, ...dataToSend } = data.data
    /* eslint-enable @typescript-eslint/no-unused-vars */
    if (submit) submit({...data, data: dataToSend})
  }

  const {
    setFormData,
    formData,
    emptyValidation,
    handleInputChange,
    handleSubmit,
    configData,
    toggleShowByName,
  } = useForm(props.fetchedData, config({ currencies: dropdownOptions.currencies, timezones: timezones, formType: props.formType }), submitForm)

  useEffect(() => {
    toggleShowByName(
      'treasurydepartmentReasons',
      formData?.isTreaurydepartment?.value === 'false'
    )
  }, [formData?.isTreaurydepartment?.value])

  useEffect(() => {
    toggleShowByName(
      'isPaymentProcessed',
      formData?.isUsingTreasury?.value === 'usingGroup'
    )
    toggleShowByName(
      'isInterCompanyFunding',
      formData?.isUsingTreasury?.value === 'usingGroup'
    )
    toggleShowByName(
      'isTreaurydepartment',
      formData?.isUsingTreasury?.value === 'usingGroup'
    )
  }, [formData?.isUsingTreasury?.value])

  useEffect(() => {
    if(!initialRender) {
      const timeSplitted = formData.cutoffTimeForBusiness.value.split(' ')

      setFormData(prev => {
        const timezoneIndex = timezones?.findIndex(timezone => timezone?.label.includes(timeSplitted[1])) || '0'
        prev.cutoffTimeForBusiness.value = timeSplitted[0]
        prev.timezonesDropdown.value = timezoneIndex?.toString()
        return prev
      })
    }
    setInitialRender(true)
  }, [formData.cutoffTimeForBusiness.value])

  return (
    <FormStyle onSubmit={handleSubmit}>
      <FormHeader>
        <FormTitle>
          {t('onboarding.forms.CorporateAccount.BankDetailsForm.title')}
        </FormTitle>
        <FormDescription>
          {/* @ts-ignore-next-line */}
          <Trans i18nKey='onboarding.forms.CorporateAccount.BankDetailsForm.description' />
        </FormDescription>
      </FormHeader>
      {utils.sectionBuilder(configData, formData, handleInputChange)}
      <FormFooter noOfButtons={2}>
        <FormFooterActionsLeft>
          <Button
            label={t('onboarding.main.backButton')}
            version={2}
            disabled={props.disablePrev}
            onClick={props.prevStep}
          />
        </FormFooterActionsLeft>
        <FormFooterActionsRight>
          <Button
            type='submit'
            label={props.isLastForm ? t('onboarding.main.saveAndSubmit') : t('onboarding.main.continueButton')}
            disabled={emptyValidation || formData.timezonesDropdown.value === ''}
          />
        </FormFooterActionsRight>
      </FormFooter>
    </FormStyle>
  )
}

export default BankDetailsForm
